import { ConfirmMfaSetup, RecoveryCodes } from '@playq/octopus2-auth';
import { GenericFailure } from '@playq/services-shared';

import { services2 } from '/api/services2';
import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';
import { snackbarService } from '/common/snackbarService';

import { userProfileKey } from './useUpdateProfile';

const userProfileRequestMfaKey = userProfileKey.concat('requestMFA');

export const useConfirmUserMFA = (
  options?: UseMutationOptionsExtended<RecoveryCodes, GenericFailure | Error, ConfirmMfaSetup>
) =>
  useEitherMutation((mfa) => services2.userProfileService.confirmMfaSetup(mfa), {
    mutationKey: userProfileRequestMfaKey,
    onError: (err) => {
      snackbarService.error('Could not request MFA. Message: ', err.message);
    },
    ...options,
  });
